<nav #navbarAccounts class="navbar navbar-expand-xl navbar-dark text-white fixed-top bg-1">
  <a class="navbar-brand text-center p-0" routerLink="balance">
    <img [src]="'assets/logos/logo-white.png'" width="100" height="82%" class="d-inline-block align-top" alt="">
    <p class="m-0 p-0 bottom-center text-white text-center smallHomeUrl">{{ "accounts.menu.home" | translate}}</p>
  </a>

  <div class="me-2 mb-2">
    <div *ngIf="(profileDetail?.customerStatus === eCustomerStatus.ACTIVE || profileDetail?.customerStatus === eCustomerStatus.PENDING ) && profileDetail?.commissionSchemeType === eCommissionSchemeType.REFERRED && applicationConfiguration?.brokerEnabled && applicationConfiguration?.brokerEnabledInviteFriend">
      <a class="btn btn-primary" (click)="referFriend()" *ngIf="applicationStatus === ApplicationStatus.APPROVED">
        <i class="fas fa-user-friends"></i>&nbsp;{{ "accounts.menu.refer-friend" | translate}}
      </a>
      <a class="btn btn-primary" (click)="showReferrerSettings()" *ngIf="applicationStatus != ApplicationStatus.APPROVED">
        <i class="fas fa-user-friends"></i>&nbsp;{{ "accounts.menu.refer-friend" | translate}}
      </a>
    </div>
  </div>

  <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <div class="d-flex flex-column justify-content-center align-items-center">
      <i class="fas fa-bars"></i>
      <p class="menu-small">{{ "accounts.menu.menu" | translate }}</p>
    </div>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav me-auto">
      <li class="nav-item" *ngIf="(profileDetail?.customerStatus === eCustomerStatus.ACTIVE || profileDetail?.customerStatus === eCustomerStatus.PENDING ) && profileDetail?.commissionSchemeType === eCommissionSchemeType.REFERRED && applicationConfiguration?.brokerEnabled && applicationConfiguration?.brokerEnabledInviteFriend">
        <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" (click)="showReferrerCodeModal()" aria-haspopup="true">{{ "accounts.menu.referral-code" | translate}}</a>
      </li>

      <li *ngIf="getProfileDetail()?.customerStatus == eCustomerStatus.ACTIVE && getProfileDetail().commissionSchemeType === eCommissionSchemeType.REFERRED && ((getProfileDetail()?.altairParentAgentId === null && getProfileDetail().parentAssociation) || applicationConfiguration?.brokerEnabledInviteFriend)" class="nav-item dropdown text-left">
        <a class="nav-link dropdown-toggle text-left" href="#" id="referralsDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ "accounts.menu.referrals-menu" | translate}}</a>
        <div class="dropdown-menu" aria-labelledby="referralsDropdown">
          <a class="dropdown-item text-center-responsive" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active" routerLink="addReferral" *ngIf="getProfileDetail()?.altairParentAgentId === null && getProfileDetail().parentAssociation">{{ "accounts.menu.referral-invite" | translate}}</a>
          <a class="dropdown-item text-center-responsive" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active" routerLink="myReferrals" *ngIf="applicationConfiguration?.brokerEnabledInviteFriend">{{ "accounts.menu.referral-rewards" | translate}}</a>
          <a class="dropdown-item text-center-responsive" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active" routerLink="referralCode" *ngIf="getProfileDetail()?.altairAgentCode != null && applicationConfiguration?.brokerEnabledInviteFriend">{{ "accounts.menu.referral-code" | translate}}</a>
        </div>
      </li>

      <li *ngIf="((customerProfileService?.getPinAvailable() && configuration.enablePinReset) || !configuration.enablePinReset) && getProfileDetail()?.mediaAccessStatus == eMediaAccessStatus.ACTIVE" class="nav-item">
        <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLink="transactionHistory" aria-haspopup="true">{{ "accounts.menu.transaction-history" | translate}}</a>
      </li>

      <li *ngIf="((customerProfileService?.getPinAvailable() && configuration.enablePinReset) || !configuration.enablePinReset) && configuration?.hasCardLoads && getProfileDetail()?.mediaAccessStatus == eMediaAccessStatus.ACTIVE" class="nav-item text-center mb-2">
        <a class="nav-link text-left" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLink="newCode" aria-haspopup="true">{{ "accounts.menu.deposit-locations" | translate}}</a>
      </li>

      <li *ngIf="((customerProfileService?.getPinAvailable() && configuration.enablePinReset) || !configuration.enablePinReset) && getProfileDetail()?.customerStatus == eCustomerStatus.ACTIVE && getProfileDetail()?.mediaAccessStatus == eMediaAccessStatus.ACTIVE && (configuration.enableInternalTransfers || configuration.enableInternationalTransfers)" class="nav-item text-center mb-2">
        <a class="nav-link text-left" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active" routerLink="transfers">{{ "accounts.menu.card-to-card" | translate}}</a>
      </li>

      <li class="nav-item dropdown text-left">
        <a class="nav-link dropdown-toggle text-left" href="#" id="toolsDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ "accounts.menu.security-settings" | translate}}</a>
        <div class="dropdown-menu" aria-labelledby="toolsDropdown">
          <a class="dropdown-item text-center-responsive" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active" routerLink="passwordChange">{{ "accounts.menu.change-password" | translate}}</a>
          <a class="dropdown-item text-center-responsive" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active" routerLink="emailChange" *ngIf="getProfileDetail()?.customerStatus != eCustomerStatus.IN_CREATION">{{ "accounts.menu.change-email" | translate}}</a>
          <a class="dropdown-item text-center-responsive" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" style="cursor: pointer" *ngIf="configuration?.enablePinReset && !customerProfileService?.getPinAvailable() && customerDetail?.mediaAccess?.status == eMediaAccessStatus.ACTIVE" (click)="openModal(nipCreation, eModalSize.MD);">{{ "accounts.menu.set-pin" | translate}}</a>
          <a class="dropdown-item text-center-responsive" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" style="cursor: pointer" *ngIf="configuration?.enablePinChange && customerProfileService?.getPinAvailable() && customerDetail?.mediaAccess?.status == eMediaAccessStatus.ACTIVE" (click)="openModal(nipChange, eModalSize.MD);">{{ "accounts.menu.change-pin" | translate}}</a>
          <a class="dropdown-item text-center-responsive" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" style="cursor: pointer" *ngIf="configuration?.enableFamilyHealth && familyHealthService?.status === eFamilyHealthStatus.ACTIVE && !familyHealthService?.canceled" (click)="showCancelFamilyHealth = true;">{{ "accounts.menu.family-health-cancel" | translate}}</a>
        </div>
      </li>

      <li *ngIf="getProfileDetail()?.customerStatus == eCustomerStatus.ACTIVE" class="nav-item dropdown text-left">
        <a class="nav-link dropdown-toggle text-left" href="#" id="accountContractsDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ "accounts.menu.account-contracts" | translate}}</a>
        <div class="dropdown-menu" aria-labelledby="accountContractsDropdown">
          <a class="dropdown-item truncate text-center-responsive" [href]="urlDoc3" target="_blank">{{this.title3 + (this.subtitle3 ? ' (' + this.subtitle3 + ')' : '') }}</a>
          <a class="dropdown-item truncate text-center-responsive" [href]="urlDoc1" target="_blank">{{this.title1 + (this.subtitle1 ? ' (' + this.subtitle1 + ')' : '')}}</a>
          <a class="dropdown-item truncate text-center-responsive" [href]="urlDoc5" target="_blank">{{this.title5 + (this.subtitle5 ? ' (' + this.subtitle5 + ')' : '')}}</a>
          <a class="dropdown-item truncate text-center-responsive" [href]="urlDoc4" target="_blank">{{this.title4 + (this.subtitle4 ? ' (' + this.subtitle4 + ')' : '')}}</a>
          <a class="dropdown-item truncate text-center-responsive" [href]="urlDDA"  target="_blank">{{this.title6 + (this.subtitle6 ? ' (' + this.subtitle6 + ')' : '')}}</a>
        </div>
      </li>

      <li *ngIf="((customerProfileService?.getPinAvailable() && configuration.enablePinReset) || !configuration.enablePinReset) && getProfileDetail()?.customerStatus == eCustomerStatus.ACTIVE" class="nav-item text-left mb-2">
        <a class="nav-link text-left" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLink="accountStatement">{{ "accounts.menu.account-statements" | translate}}</a>
      </li>

      <li class="nav-item text-left mb-2">
        <a class="nav-link text-left" routerLink="contactUsAccount" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">{{ "accounts.menu.contact-us" | translate}}</a>
      </li>

      <li *ngIf="configuration.enableShowFaqsScreen" class="nav-item text-right mb-2">
        <a class="nav-link text-left" routerLink="faq" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" i18n="@@faq">FAQ</a>
      </li>
    </ul>

    <div class="text-left">
      <a class="btn btn-primary" (click)="logout()">{{ "accounts.menu.session-logout" | translate}}</a>
    </div>

    <div class="text-center">
      <a class="nav-item nav-link d-inline-block flags-pointer" (click)="changeLanguage('es');setLanguage('es')">
        <img src="assets/flags/es.png" height="20" class="align-top" alt="">
      </a>
      <a class="nav-item nav-link d-inline-block flags-pointer" (click)="changeLanguage('en');setLanguage('en')">
        <img src="assets/flags/en.png" height="20" class="align-top" alt="">
      </a>
    </div>
  </div>
</nav>

<!--TODO esto según yo ya no debería jalar, ya que el toasta hace esta función, hay que quitarlo-->
<div class="notifications position-fixed m-4 mt-5 pt-3">
  <div *ngFor="let notif of this.getMsg();let index = index"
       class="alert alert-{{notif.color}} alert-dismissible p-2 shadow-sm" role="alert">
    <h5 class="card-title mb-1"><i class="{{notif.icon}}"></i> {{notif.title}}
      <small>{{notif.status}}</small>
    </h5>
    <p class="mb-0">{{notif.description}}</p>
    <div *ngIf="notif.description2">
      <hr class="m-1">
      <p class="mb-0">{{notif.description2}}</p>
    </div>
    <ul *ngIf="notif.arrayData?.length>0">
      <li *ngFor="let msg of notif.arrayData">{{msg}}</li>
    </ul>
    <div *ngIf="notif.button" class="row">
      <div class="col">
        <button type="button" style="border-color: #856404!important;" class="btn alert-warning float-right" (click)="this.activationCardHelp()" i18n="@@accountActiveCard">¿Cómo activar mi tarjeta?</button>
      </div>
    </div>

  </div>
</div>

<main class="main" id="top_main">
  <div class="container nav-space">
    <router-outlet></router-outlet>
  </div>
</main>

<app-footer></app-footer>

<!-- Modal PIN Creation -->
<ng-template #nipCreation let-modal>
  <div>
    <div class="modal-header">
      <h4 i18n="@@balance_nipChange">Crea tu PIN</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body justify-content-center text-center">
      <form #formCreateNip="ngForm" (ngSubmit)="formCreateNip.form.valid && resetNip(modal)" [matchNip]="['pinValue', 'confirmPinValue']">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="form-group">
              <label i18n="@@balance_nipCreation_instructions">Coloca los cuatro dígitos de tu nuevo PIN</label>
              <div class="input-group">
                <div class="input-group-append">
                  <button class="btn btn-outline-success rounded-left" type="button" *ngIf="showNewNip"
                          (click)="showNewNip = false"><i class="fas fa-eye"></i></button>
                  <button class="btn btn-outline-primary rounded-left" type="button" *ngIf="!showNewNip"
                          (click)="showNewNip = true"><i class="fas fa-eye-slash"></i></button>
                </div>
                <input [type]="showNewNip ? 'text' : 'password'" class="form-control" name="pinValue"
                       [(ngModel)]="pin" #pinValue="ngModel" maxlength="4" minlength="4"
                       [ngClass]="inputFieldCss(pinValue, formCreateNip)" numbers required>
              </div>
            </div>
            <app-field-error-display [control]="pinValue" [form]="formCreateNip"></app-field-error-display>
            <div>
              <label class="float-right mt-2">
                <input type="checkbox" name="newNip" value="nip" [(ngModel)]="showNewNip">{{ "accounts.menu.show-nip" | translate }}
              </label>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label i18n="@@balance_confirmNip">Confirma tu PIN</label>

              <div class="input-group">
                <div class="input-group-append">
                  <button class="btn btn-outline-success rounded-left" type="button" *ngIf="confirmNip"
                          (click)="confirmNip = false"><i class="fas fa-eye"></i></button>
                  <button class="btn btn-outline-primary rounded-left" type="button" *ngIf="!confirmNip"
                          (click)="confirmNip = true"><i class="fas fa-eye-slash"></i></button>
                </div>
                <input [type]="confirmNip ? 'text' : 'password'" class="form-control" name="confirmPinValue"
                       [(ngModel)]="confirmPin" #confirmPinValue="ngModel" maxlength="4" minlength="4"
                       [ngClass]="inputFieldCss(confirmPinValue, formCreateNip)" numbers required>
              </div>
              <app-field-error-display [control]="confirmPinValue" [form]="formCreateNip"></app-field-error-display>
              <div>
                <label class="float-right mt-2">
                  <input type="checkbox" name="confirm nip" value="nip" [(ngModel)]="confirmNip">{{ "accounts.menu.show-nip" | translate }}
                </label>
              </div>
            </div>
          </div>
          <div class="btn-group">
            <button type="submit" class="btn btn-outline-primary" i18n="@@balance_create">Crear</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<!-- Modal PIN Change -->
<ng-template #nipChange let-modal>
  <div>
    <div class="modal-header">
      <h4 i18n="@@balance_nipChange">Cambia tu PIN</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body justify-content-center text-center">
      <form #formChangeNip="ngForm" (ngSubmit)="formChangeNip.form.valid && changeNip()" [matchNip]="['pinValue', 'confirmPinValue']">
        <div class="row justify-content-center">
          <div class="col-12">

            <div class="form-group">
              <label i18n="@@balance_oldNip_instructions">Coloca los cuatro dígitos de tu PIN actual</label>
              <div class="input-group">
                <div class="input-group-append">
                  <button class="btn btn-outline-success rounded-left" type="button" *ngIf="changeNewNip"
                          (click)="changeNewNip = false"><i class="fas fa-eye"></i></button>
                  <button class="btn btn-outline-primary rounded-left" type="button" *ngIf="!changeNewNip"
                          (click)="changeNewNip = true"><i class="fas fa-eye-slash"></i></button>
                </div>
                <input [type]="changeNewNip ? 'text' : 'password'" class="form-control" name="oldPinValue"
                       [(ngModel)]="oldPin" #oldPinValue="ngModel" maxlength="4" minlength="4"
                       [ngClass]="inputFieldCss(oldPinValue, formChangeNip)" numbers required>
              </div>
            </div>
            <app-field-error-display [control]="oldPinValue" [form]="formChangeNip"></app-field-error-display>
            <div>
              <label class="float-right mt-2">
                <input type="checkbox" name="newNip" value="nip" [(ngModel)]="changeNewNip">{{ "accounts.menu.show-nip" | translate }}
              </label>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label i18n="@@balance_newNip_instructions">Coloca los cuatro dígitos de tu nuevo PIN</label>
              <div class="input-group">
                <div class="input-group-append">
                  <button class="btn btn-outline-success rounded-left" type="button" *ngIf="changeNewNipDigits"
                          (click)="changeNewNipDigits = false"><i class="fas fa-eye"></i></button>
                  <button class="btn btn-outline-primary rounded-left" type="button" *ngIf="!changeNewNipDigits"
                          (click)="changeNewNipDigits = true"><i class="fas fa-eye-slash"></i></button>
                </div>
                <input [type]="changeNewNipDigits ? 'text' : 'password'" class="form-control" name="pinValue"
                       [(ngModel)]="pin" #pinValue="ngModel" maxlength="4" minlength="4"
                       [ngClass]="inputFieldCss(pinValue, formChangeNip)" numbers required>
              </div>
            </div>
            <app-field-error-display [control]="pinValue" [form]="formChangeNip"></app-field-error-display>
            <div>
              <label class="float-right mt-2">
                <input type="checkbox" name="newNip" value="nip" [(ngModel)]="changeNewNipDigits">{{ "accounts.menu.show-nip" | translate }}
              </label>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label i18n="@@balance_confirmNip">Confirma tu PIN</label>
              <div class="input-group">
                <div class="input-group-append">
                  <button class="btn btn-outline-success rounded-left" type="button" *ngIf="confirmNewNip"
                          (click)="confirmNewNip = false"><i class="fas fa-eye"></i></button>
                  <button class="btn btn-outline-primary rounded-left" type="button" *ngIf="!confirmNewNip"
                          (click)="confirmNewNip = true"><i class="fas fa-eye-slash"></i></button>
                </div>
                <input [type]="confirmNewNip ? 'text' : 'password'" class="form-control" name="confirmPinValue"
                       [(ngModel)]="confirmPin" #confirmPinValue="ngModel" maxlength="4" minlength="4"
                       [ngClass]="inputFieldCss(confirmPinValue, formChangeNip)" numbers required>
              </div>
            </div>
            <app-field-error-display [control]="confirmPinValue" [form]="formChangeNip"></app-field-error-display>
            <div>
              <label class="float-right mt-2">
                <input type="checkbox" name="newNip" value="nip" [(ngModel)]="confirmNewNip">{{ "accounts.menu.show-nip" | translate }}
              </label>
            </div>
          </div>
          <div class="btn-group">
            <button type="submit" class="btn btn-outline-primary" i18n="@@balance_change">Cambiar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<!-- Dialog to show referrer settings -->
<p-dialog class="referrer-header" header=" " [(visible)]="showReferrerModal" [modal]="true" [draggable]="false" [resizable]="false">
  <div class="d-flex flex-column align-items-center justify-content-center">
    <i class="fas fa-info-circle fa-2x text-primary"></i>
    <p class="text-center mt-1">{{"accounts.referred.code.no-show-broker-code-pt1" | translate }}<br>{{"accounts.referred.code.no-show-broker-code-pt2" | translate }}<br>{{"accounts.referred.code.no-show-broker-code-pt3" | translate }}</p>
  </div>
</p-dialog>

<!-- Dialog to show your referral code -->
<p-dialog class="referrer-header text-center" header=" " [(visible)]="showReferrerCode" [modal]="true" [baseZIndex]="10000" [draggable]="false" [resizable]="false" [style]="{ width: '300px' }">
  <img [src]="'assets/logos/logo.png'" style="width: 100%;max-width: 200px; margin-bottom: 20px" alt="">

  <p-card class="text-center" (click)="copyMyReferralCode()" [style]="{
        border: '2px solid black',
        borderRadius: '15px',
        cursor: 'pointer'

    }">
    <ng-template pTemplate="header">
      <p class="text-center mt-1">{{"accounts.menu.referral-code" | translate }}</p>
    </ng-template>

    <h3>{{getProfileDetail()?.altairAgentCode?.toLowerCase()}}</h3>

    <ng-template pTemplate="footer">
      <div class="d-flex flex-row justify-content-center align-items-center cursor-ponter-class" >
        <i class="far fa-copy card__copy"></i>
        <p class="card-copy-text ">{{ "accounts.balance.copy" | translate }}</p>
      </div>
    </ng-template>
  </p-card>
</p-dialog>

<!-- Family Card Health Cancel dialog --->
<p-dialog header=" " [(visible)]="showCancelFamilyHealth" [modal]="true" [baseZIndex]="10000">
  <div class="d-flex align-items-center justify-content-center flex-column">
    <i class="fas fa-exclamation-triangle fa-2x notification-triangle-icon"></i>
    <p>{{ "accounts.menu.family-health-cancel-message" | translate}}</p>
  </div>
  <div class="d-flex justify-content-between">
    <button type="button" class="btn btn-outline-primary btn-yesno-width" (click)="showCancelFamilyHealth = false">{{ "accounts.menu.no" | translate}}</button>
    <button type="button" class="btn btn-outline-success ml-3 btn-yesno-width" (click)="cancelFamilyHealth(); showCancelFamilyHealth = false;">{{ "accounts.menu.yes" | translate}}</button>
  </div>
</p-dialog>


